import React from 'react';
import { changeIsNewShape, selectShape } from '../../../actions/CurrentSlideActions';
import { refreshTextEditorTool } from '../../../actions/MenuActions';
import { InteractiveShape } from '../interactive/InteractiveShape';
import properties from '../../../constants/Properties';
import animationManager from '../../utils/AnimationManager';
import modeType from '../../../constants/ModeConstants';
import previewCommands from '../../utils/PreviewCommands';
import appParameters from '../../utils/AppParameters';
import createShapes from '../../utils/CreateShapes';
import localesManager from '../../../locales/LocalesManager';
import storeManager from '../../../store/StoreManager';
import mouseUtils from '../../utils/MouseUtils';
import screamBubbleUtils from './utils/ScreamBubbleUtils';
import textEditorUtils from '../../menus/textEditorTool/utils/TextEditorUtils';

export const ScreamBubbleRich = React.createClass({
    componentDidMount() {
        if (this.refs.shapeTextArea && this.props.shapeModel.htmlText)
            this.refs.shapeTextArea.innerHTML = textEditorUtils.getHtmlText(this.props.shapeModel);
    },
    componentWillReceiveProps(nextProps) {
        if (textEditorUtils.isTextEditorTool())
            return;

        if (this.props.shapeModel.htmlText != nextProps.shapeModel.htmlText && this.refs.shapeTextArea)
            this.refs.shapeTextArea.innerHTML = textEditorUtils.getHtmlText(nextProps.shapeModel);

        // when a new shape is added to canvas, force focus to interactive element
        if (this.props.shapeModel.isNew != nextProps.shapeModel.isNew)
            this.setFocusToInteractiveElement();

        // when an element becomes selected (state 2) using multiple selection, the focus should be on interactiveElement to can have a keyDown event in case we type something to enter in Text Editor (state 3) because textArea is disabled at that time
        if (nextProps.shapeModel.isSelected && this.props.shapeModel.isSelected != nextProps.shapeModel.isSelected)
            this.setFocusToInteractiveElement();
    },
    setFocusToInteractiveElement() {
        setTimeout(function() {
            if (this.refs.focusableElement) // force focus to interactive element to can handle on KeyDown on it because we can't get key events on textArea while disabled
                this.refs.focusableElement.focus();
        }.bind(this), 2);
    },
    checkIfIsNewShape() {
        if (previewCommands.isPlayMode())
            return;

        const { shapeModel, dispatch} = this.props;

        if (shapeModel.isNew == true)
            setTimeout(function() {
                dispatch(changeIsNewShape(shapeModel.uuid, false));
            }.bind(this), 2);
    },
    isShapeSelected() {
        const currentSlide = storeManager.getState().currentSlide;

        if (currentSlide && currentSlide.model && currentSlide.model.content) {
            const shapes = currentSlide.model.content;
            var i;

            for (i = 0; i < shapes.length; i++)
                if (shapes[i].uuid == this.props.shapeModel.uuid) {
                    if (shapes[i].isSelected == true)
                        return true;
                    else
                        return false;
                }

            return false;
        }

        return false;
    },
    isContentEditable() {
        if (appParameters.isCartoonistPlayer())
            return false;

        let clone = animationManager.getCloneByUid(this.props.shapeModel.uuid);

        if (!clone)
            clone = animationManager.clone;

        if ((clone && this.props.shapeModel.uuid == clone.uuid) || (animationManager.target && this.props.shapeModel.uuid == animationManager.target.uuid)) // non editable in animation mode
            return false;

        if (textEditorUtils.isTextEditorTool())
            return true;
        else
            return false;
    },

    /************ text area *************/
    onChangeText(e) {
        if (previewCommands.isPlayMode())
            return;

        if (e.nativeEvent && e.nativeEvent.inputType === 'insertFromPaste') {
            let txt = this.refs.shapeTextArea.innerText;
            this.refs.shapeTextArea.innerHTML = '<span style="font-family: Cabin; font-size: 24px; white-space: pre-wrap">' + txt + '</span>';
        } else
            textEditorUtils.checkForSizeAttribute(this.refs.shapeTextArea);

        // console.log('aaaa ' + document.getElementById('text_area_' + this.props.shapeModel.uuid).innerHTML);

        textEditorUtils.resetActions();
        textEditorUtils.updateShapeSize(this.props.shapeModel, this.props.dispatch);
    },
    onTextAreaClick() {
        var selection = window.getSelection();

        if (selection.anchorOffset == selection.extentOffset && textEditorUtils.lastCursorPosition >= 0 && selection.anchorOffset == textEditorUtils.lastCursorPosition) { // no text selected and only the cursor pointer
            // if a text size was changed while no text selection and you will click on the same cursor position, then we should use the selected text size
        } else {
            textEditorUtils.resetActions();
        }

        if (textEditorUtils.isTextEditorTool()) // if the textEditor is opened then should refresh it at every click to can updated properly the right buttons
            setTimeout(function() {
                this.props.dispatch(refreshTextEditorTool());
            }.bind(this), 5);
        else
            this.checkTextEditorTool();
    },
    checkTextEditorTool() { // check to see if TEXT EDITOR tool can be opened
        if (storeManager.getState().menu.contextMode == modeType.SIZE_AND_POSITION_CONTEXT || storeManager.getState().menu.contextMode == modeType.ANIMATION_CONTEXT)
            return;

        if (!this.props.shapeModel.isSelected)
            return;

        this.setFocusToInteractiveElement(); // force focus to interactive element to can handle on KeyDown on it because we can't get key events on textArea while disabled

        if (textEditorUtils.isClick && textEditorUtils.isShapeAlreadySelected)
            textEditorUtils.openTextEditorTool(this.props.shapeModel);
    },
    onFocusTextArea() {
        this.onFocusHandler();
    },
    handleKeyDown(e) { // when a key is down on text area
        if (e.keyCode === 27 && this.refs.shapeTextArea === document.activeElement) { // ESCAPE when the focus is on text ... close TEXT EDITOR mode ... next TAB should go to the hamburger menu
            textEditorUtils.closeTextEditor();
            return;
        }

        if (e.keyCode === 9) { // when TAB is down, then the focus will go to the CLOSE button on the TEXT EDITOR tool.
            var closeButtonOnTextEditorTool = document.getElementById('firstFocusableObjectForTextEditorTool');

            if (closeButtonOnTextEditorTool) {
                setTimeout(function() {
                    closeButtonOnTextEditorTool.focus();
                }.bind(this), 2);
            }

            return;
        }

        if (textEditorUtils.isTextEditorTool()) {
            // The user might move the insertion point with the arrow keys, so this will update the selected text types (only) on arrow key presses.
            const arrowKeys = [37, 38, 39, 40];

            if (arrowKeys.includes(e.keyCode)) // if is textTool is opened and move arrow keys then update the right buttons
                setTimeout(function() {
                    textEditorUtils.resetActions();
                    this.props.dispatch(refreshTextEditorTool());
                }.bind(this), 10);
        }
    },

    /*************** interactive element ***************/
    onKeyDown(e) { // when key down on the interactive element
        if (e.ctrlKey == true || e.altKey == true) // when commands keys don't open TEXT EDITOR
            return;

        const arrowKeys = [9, 27, 8, 46, 37, 38, 39, 40, 16]; // TAB, ESCAPE, BACKSPACE ,DELETE and arrow keys, SHIFT

        if (arrowKeys.includes(e.keyCode)) { // some keys are used for removing shape, moving shape or to change the tab
            textEditorUtils.resetActions();
            return;
        }

        if (document.activeElement.id.indexOf('interactiveElement') != -1) // if interactive element is selected
            textEditorUtils.openTextEditorTool(this.props.shapeModel, {key: e.key, keyCode: e.keyCode});
    },
    onFocusHandler() { // on focus interactive element
        if (document.activeElement == this.refs.focusableElement) {
            if (!this.isShapeSelected()) {
                textEditorUtils.closeTextEditor();
                this.props.dispatch(selectShape(this.props.shapeModel.uuid));
            }
        }

        mouseUtils.activeElement = this.props.shapeModel.uuid;
        this.checkTextLabel();
    },
    checkTextLabel() {
        setTimeout(function() {
            var textLabelElement = document.getElementById('textBoxLabel');

            if (textLabelElement)
                textLabelElement.style.display = 'block';
        }.bind(this), 3);
    },
    shouldComponentUpdate(newProps) {
        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties)
            return true;
        else
            return false;
    },
    render() {
        this.checkIfIsNewShape();

        const { shapeModel, dispatch } = this.props;
        let x = shapeModel.x;
        let y = shapeModel.y;
        const PADDING = properties.TEXT_PADDING;
        const INNER_PADDING = properties.TEXT_INNER_PADDING;
        const textProperties = textEditorUtils.textProperties(shapeModel);
        const EXTRA_PADDING = textProperties.extraPadding;

        var textAreaStyle = {
            width: shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING,
            height: shapeModel.height - 2 * PADDING - 2 * INNER_PADDING,
            resize: 'none',
            overflow: 'hidden',
            padding: INNER_PADDING,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            wordSpacing: textProperties.wordSpacing,
            letterSpacing: textProperties.letterSpacing,
            overflowWrap: 'break-word',
            cursor: 'text'
        };

        if (shapeModel.lineHeight > 0)
            textAreaStyle.lineHeight = shapeModel.lineHeight;
        else {
            if (textProperties.lineHeight != -1)
                textAreaStyle.lineHeight = textProperties.lineHeight;
        }

        let path = '';

        if (!shapeModel.path) {
            path = screamBubbleUtils.getPath(shapeModel);
            shapeModel.path = path;
        } else {
            path = shapeModel.path;
        }

        var backgroundOpacity;

        if (shapeModel.backgroundVisible == false)
            backgroundOpacity = 0;
        else
            backgroundOpacity = 1;

        var arabic = /[\u0600-\u06FF]/;

        if (arabic.test(shapeModel.htmlText))
            textAreaStyle.direction = 'rtl';

        var isContentEditable = this.isContentEditable();
        var shapeIndex = createShapes.getShapeIndex(shapeModel.uuid);
        var ariaLabelValue = localesManager.getCaption('tekst', 'other') + ' ' + shapeIndex;
        var textAreaId = 'text_area_' + shapeModel.uuid;
        var tabIndexValue;

        if (!isContentEditable)
            textAreaStyle.cursor = 'default';

        if (!this.isShapeSelected())
            tabIndexValue = -1;

        return (
            <InteractiveShape shapeModel={shapeModel} dispatch={dispatch} rotatable={true} isBubble={true} scaleProperties={this.props.scaleProperties}>
                <g transform={`translate(${x} ${y})`} opacity={shapeModel.opacity}>
                    <path
                        d={path}
                        filter={shapeModel.filter}
                        opacity={shapeModel.opacity}
                        fill={shapeModel.fill}
                        fillOpacity={backgroundOpacity}
                        stroke={shapeModel.stroke}
                        strokeWidth={shapeModel.strokeWidth}
                        strokeOpacity={shapeModel.strokeOpacity}
                        preserveAspectRatio="none" />
                    <foreignObject x={PADDING} y={PADDING} width={shapeModel.width - 2 * PADDING} height={shapeModel.height - 2 * PADDING}>
                        {
                            !shapeModel.isGrouped ?
                                <a id={'interactiveElement_' + this.props.shapeModel.uuid} ref='focusableElement' href='' onFocus={this.onFocusHandler} onKeyDown={this.onKeyDown}></a>
                                : null
                        }
                        <div id={textAreaId} tabIndex={tabIndexValue} ref='shapeTextArea' className='textShapes' role='textbox' aria-label={ariaLabelValue} aria-multiline='true' style={textAreaStyle} contentEditable={isContentEditable} suppressContentEditableWarning={true} spellCheck='false' autoCorrect='off' autoCapitalize='off' autoComplete='off' onTouchEnd={this.onTextAreaClick} onMouseUp={this.onTextAreaClick} onKeyDown={this.handleKeyDown} onInput={this.onChangeText} onFocus={this.onFocusTextArea}/>
                    </foreignObject >
                </g>
            </InteractiveShape>
        );
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/slide/shapes/ScreamBubbleRich.js
 **/